<template>
	<useTable :searchForm="searchForm" :httprequest="httprequest" ref="useTable" :headerList="headerData" :showEmptyTable="false"></useTable>
</template>
<script>
import useTable from '@/components/useTable/useTable.vue'
import { mapActions } from 'vuex'
import { ElTooltip } from 'element-ui'
export default {
	data() {
		const statusList = [
			{
				label: '全部',
				value: ''
			},
			
			{
				label: '审核中',
				value: 1
			},
			{
				label: '审核驳回',
				value: 2
			},
			{
				label: '审核通过',
				value: 3
			},
		]
		return {
			commonName: 'cardList',
			searchObj: {},
			searchForm: [
				{
					defaultValue: '',
					label: '手机号:',
				    Component: 'el-input',
					prop: 'phone',
				    componentProps: {
						type: 'tel',
				        placeholder: '请输入手机号',
						clearable: true
				    }
				},
				{
					Component: 'el-button',
					span: 4,
				    componentProps: {
				       type: "primary"
				    },
				    renderHTML: () => {
				        return '查询'
				    },
				    on: {
				        click: this.getCardList
				    }
				}
			],
			headerData: [
				{
					props: {
				        prop: 'source_type_desc',
				        label: '来源',
				        width: 100
				    }
				},
				{
					props: {
				        prop: 'dynickname',
				        label: '用户信息',
				        width: 120
				    }
				},
				{
					props: {
				        prop: 'user_name',
				        label: '姓名',
				        width: 120
				    }
				},
				{
					props: {
                        prop: 'phone',
                        label: '手机号',
						width: 150
                    }
				},
				{
					props: {
				        prop: 'city',
				        label: '城市',
				    }
				},
				{
					props: {
				        prop: 'remark',
				        label: '备注',
						width: 150
				    }
				},
                {
                    props: {
                        label: '操作',
                        width: 220
                    },
                    render:(h, scope)=> {
                    	if(!scope.row.tips_status){
                    		return (
                    		<div class="remark">
                    			<span style="color:#409eff" onClick={this.hiddenTips.bind(this,scope)}>{scope.row.remark ? '修改备注':'添加备注'}</span>
                    		</div>
                    	)
                    	}else{
                    		return (
                    		<div class="remark"> 
                    			<el-input placeholder="添加备注" size="small" v-model={scope.row.remark_desc} onBlur={this.showTips.bind(this,scope)}></el-input>
                    		</div>
                    	)
                    	}
                        
                    }
                }
			]
		}
	},
	components: {
		useTable
	},
	created() {
		this.searchObj = this.$route.params
	},
	methods: {
		...mapActions('dymessage', ['cardsUserinfo','cardsUserinfoRemark']),
		getCardList() {
			this.$refs.useTable.getRequestRes('firstPage')
		},
		hiddenTips(scope){
			this.$set(scope.row,'tips_status',true)
			this.$set(scope.row,'remark_desc',scope.row.remark)
		},
		async showTips(scope){
			let info = {
				id: scope.row.id,
				remark: scope.row.remark_desc
			}
			this.$set(scope.row,'tips_status',false)
			let res = await this.cardsUserinfoRemark({...info})
			this.getCardList()
		},
		async httprequest(params) {
			params.card_id = this.searchObj.card_id ? Number(this.searchObj.card_id) : ''
			params.limit = params.pageSize
			delete params.pageSize
			let res = await this.cardsUserinfo(params)
			return {total: res.count, data: res.list}
		}
	}
}
</script>
<style lang="less">
	 @classNames: cardList;
	.@{classNames}_operation_title {
			margin-right: 12px;
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
	}
	.remark{
		height: 34px;
		line-height: 34px;
	}
	.material-popover {
		.content {
			img {
				max-width: 100%;
			}
		}
	}
</style>
